var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "20px",
    viewBox: "0 0 12 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Change-Password",
    transform: "translate(-72.000000, -584.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(72.000000, 584.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#53C1E4",
    x: 0,
    y: 0,
    width: 12,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,17.4 L5,18.2 C5,18.4209139 5.1790861,18.6 5.4,18.6 L6.2,18.6 C6.4209139,18.6 6.6,18.4209139 6.6,18.2 L6.6,17.4 C6.6,17.1790861 6.4209139,17 6.2,17 L5.4,17 C5.1790861,17 5,17.1790861 5,17.4 Z",
    id: "Icon-color",
    fill: "#F8F8F8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8F8F8",
    x: 4,
    y: 1,
    width: 4,
    height: 1,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8F8F8",
    x: 1,
    y: 3,
    width: 10,
    height: 13,
    rx: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3ab744d22f0060da97463cb280b7da89.svg";
export { ForwardRef as ReactComponent };